import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';

const Notification = ({ 
  type = 'info', 
  message, 
  duration = 5000, 
  onClose,
  position = 'top-left' 
}) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration]);

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300);
  };

  const typeMap = {
    success: {
      icon: <CheckCircle size={24} strokeWidth={2.5} style={{ color: 'var(--color-success)' }} />,
      bg: 'var(--color-success-bg)',
      border: 'var(--color-success-border)',
      text: 'var(--color-success-text)',
    },
    error: {
      icon: <XCircle size={24} strokeWidth={2.5} style={{ color: 'var(--color-danger)' }} />,
      bg: 'var(--color-danger-bg)',
      border: 'var(--color-danger-border)',
      text: 'var(--color-danger-text)',
    },
    warning: {
      icon: <AlertCircle size={24} strokeWidth={2.5} style={{ color: 'var(--color-warning)' }} />,
      bg: 'var(--color-warning-bg)',
      border: 'var(--color-warning-border)',
      text: 'var(--color-warning-text)',
    },
    info: {
      icon: <Info size={24} strokeWidth={2.5} style={{ color: 'var(--color-info)' }} />,
      bg: 'var(--color-info-bg)',
      border: 'var(--color-info-border)',
      text: 'var(--color-info-text)',
    },
  };

  const colors = typeMap[type] || typeMap.info;

  if (!isVisible) return null;

  const positionStyles = {
    'top-left': { top: '20px', left: '20px' },
    'top-right': { top: '20px', right: '20px' },
    'bottom-left': { bottom: '20px', left: '20px' },
    'bottom-right': { bottom: '20px', right: '20px' },
  };

  return (
    <div
      style={{
        position: 'fixed',
        ...positionStyles[position],
        zIndex: 10000,
        backgroundColor: colors.bg,
        border: `2px solid ${colors.border}`,
        borderRadius: '12px',
        padding: '20px 24px',
        minWidth: '380px',
        maxWidth: '550px',
        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.15), 0 10px 10px -5px rgba(0, 0, 0, 0.08)',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '16px',
        opacity: isExiting ? 0 : 1,
        transform: isExiting ? 'translateX(-100%)' : 'translateX(0)',
        transition: 'all 0.3s ease-in-out',
      }}
    >
      <div style={{ flexShrink: 0, marginTop: '2px' }}>
        {colors.icon}
      </div>

      <div style={{
        flex: 1,
        color: colors.text,
        fontSize: '15px', 
        lineHeight: '1.6',
        fontWeight: '500'
      }}>
        {message}
      </div>
      
      <button
        onClick={handleClose}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '6px',
          borderRadius: '6px',
          color: colors.text,
          opacity: 0.7,
          transition: 'all 0.2s',
          flexShrink: 0,
        }}
        onMouseEnter={(e) => {
          e.target.style.opacity = '1';
          e.target.style.backgroundColor = 'rgba(0, 0, 0, 0.05)';
        }}
        onMouseLeave={(e) => {
          e.target.style.opacity = '0.7';
          e.target.style.backgroundColor = 'transparent';
        }}
      >
        <X size={18} />
      </button>
    </div>
  );
};

export default Notification;
